angular.module('app.directives.loading',[]).
directive('loadingModal',
    [function($rootScope){

        return {
            scope:{
                loading:'=loading',
                loadingTitle : '=loadingTitle'
            },
            templateUrl:" views/modals/loading.html",
            controller : function($scope){
                'ngInject';

                $scope.rootScope = $rootScope;



            }
        }

    }]
);
